import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", { href: "https://docs.tom.st/impressum" }, "Impressum", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "https://docs.tom.st/datenschutz" }, "Datenschutz", -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(_ctx.$style.footer)
  }, _hoisted_4, 2))
}